module.exports = __webpack_public_path__ + "static/media/pgt108.efaecff5.jpg";